import { render, staticRenderFns } from "./BrandDetailsTextField.vue?vue&type=template&id=e94c45a8&scoped=true&"
import script from "./BrandDetailsTextField.vue?vue&type=script&lang=ts&"
export * from "./BrandDetailsTextField.vue?vue&type=script&lang=ts&"
import style0 from "./BrandDetailsTextField.vue?vue&type=style&index=0&id=e94c45a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94c45a8",
  null
  
)

export default component.exports